// The project page route. Hosts Canvas (the scene) + CanvasEditor
// (the overlay chrome). When the bootstrap in canvas/index.js sets
// `root.projectNotFound`, the NotFoundPage sibling takes over inline
// so the URL stays on the project path for retry-by-reload.

// Derive a human-readable project label from current state.
// Falls back to the URL slug so the title is never blank during load.
const projectTitle = (s) => {
  const root = s.root || s
  const data = root.data
  if (data && !root.projectNotFound) {
    return (data.name || data.key || '').trim() || null
  }
  // Fallback: read the second URL segment (/:owner/:projectSlug)
  const path = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '')
  const segs = path.split('/').filter(Boolean)
  return segs[1] || segs[0] || null
}

export const main = {
  tag: 'main',
  id: 'main-content',
  gridRow: '2',
  gridColumn: '1 / -1',
  position: 'relative',
  width: '100%',
  minHeight: '0',
  overflow: 'hidden',

  metadata: (el, s) => {
    const root = s.root || s
    if (root?.projectNotFound) return { title: 'Not found / Symbols.app' }
    // Dead single-segment routes (e.g. /notFound, /foo) land on this `/*`
    // handler before the async ensureProjectLoaded sets projectNotFound.
    // Detect them eagerly so the title is correct from the first paint.
    const path = typeof window !== 'undefined' ? window.location.pathname : (root.currentPath || '')
    const segs = path.split('/').filter(Boolean)
    if (segs.length === 1) return { title: 'Not found / Symbols.app' }
    const label = projectTitle(s)
    const title = label ? `${label} / Canvas / Symbols.app` : 'Canvas / Symbols.app'
    return { title }
  },

  onRender: (el, s) => el.call('ensureProjectLoaded', el, s),

  GridstackStyles: {
    tag: 'style',
    html: (el) => el.context.gridstackCss || ''
  },

  NotFoundPage: {
    // Rendered inside this <main>, so strip the duplicate <main> tag and id
    // that notFound.js declares for its standalone /404 route usage.
    tag: 'div',
    id: null,
    if: (el, s) => !!(s.root?.projectNotFound)
  },
  Canvas: {
    if: (el, s) => !s.root?.projectNotFound
  },
  CanvasEditor: {
    if: (el, s) => !s.root?.projectNotFound
  },
  LabsNavbar: {
    if: (el, s) => !s.root?.projectNotFound
  },
  // Right-side floating island navbar — Pages, Modes, Publish, Envs, History,
  // Members, Sharing, Search. Only on /<owner>/<key> canvas project pages.
  // Auto-extended from CanvasMainNavbar in components/.
  CanvasMainNavbar: {
    if: (el, s) => !s.root?.projectNotFound
  }
}
